import { Task } from '@/types/tasks';

const DATE_ONLY_PATTERN = /^(\d{4})-(\d{2})-(\d{2})/;

export function parseTaskDueDate(value: string | null | undefined): Date | null {
  if (!value) return null;

  const match = value.match(DATE_ONLY_PATTERN);
  if (match) {
    const [, year, month, day] = match;
    return new Date(Number(year), Number(month) - 1, Number(day));
  }

  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

export function getLocalTodayIso(): string {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function formatTaskDueDate(value: string | null | undefined): string {
  const date = parseTaskDueDate(value);
  return date ? date.toLocaleDateString('pt-BR') : 'N/A';
}

export function isTaskOverdue(task: Pick<Task, 'due_date' | 'status'>): boolean {
  if (task.status === 'COMPLETED' || task.status === 'CANCELLED') return false;

  const dueDate = parseTaskDueDate(task.due_date);
  if (!dueDate) return false;

  const today = parseTaskDueDate(getLocalTodayIso());
  return today ? dueDate < today : false;
}

export function isTaskDueToday(task: Pick<Task, 'due_date' | 'status'>): boolean {
  if (task.status === 'COMPLETED' || task.status === 'CANCELLED') return false;

  const dueDate = parseTaskDueDate(task.due_date);
  const today = parseTaskDueDate(getLocalTodayIso());
  return Boolean(dueDate && today && dueDate.getTime() === today.getTime());
}

export function getDaysUntilTaskDue(value: string | null | undefined): number | null {
  const dueDate = parseTaskDueDate(value);
  const today = parseTaskDueDate(getLocalTodayIso());

  if (!dueDate || !today) return null;

  const diffMs = dueDate.getTime() - today.getTime();
  return Math.round(diffMs / (1000 * 60 * 60 * 24));
}
